import { render, staticRenderFns } from "./WorkflowFormSubmissionCommentAttachmentList.vue?vue&type=template&id=e07b115e&"
import script from "./WorkflowFormSubmissionCommentAttachmentList.vue?vue&type=script&lang=ts&"
export * from "./WorkflowFormSubmissionCommentAttachmentList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports